import { createStore } from "vuex";
import axios from "axios";
import { openDialog } from "../utils/utils";
import homepageEditor from "./modules/homepageEditor";
import { IDLE_LOGOUT_MESSAGE, canRefresh, isRefreshRejected, refreshRequestConfig } from "../utils/consoleRefresh";
import { nextLoginGeneration } from "../utils/permReview";

export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-white",
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    layout: "default",
    userName:"",
    userImageUrl:"",
    accessToken: "",
    refreshToken: "",
    isLoading: false,
    // 모바일 사이드바 상태
    isMobileSidenavOpen: false,
    isMobileView: false,
    // 국외 허용 IP 승인 대기 건수(메뉴 배지, D-139)
    geoAllowPendingCount: 0,
    // GET /auth/introspect 응답(권한 profile.perms·모드 modes — W6, 계약 README 「introspect」). 없으면 null
    introspect: null,
    // 권한 이름표 {code: ko}(GET /perm-catalog?app=admin-certilife) — PERMISSION_DENIED 문구용
    permLabels: {},
  },
  mutations: {
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (sidenav_show.classList.contains("g-sidenav-hidden")) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    setIsLoading(state, input) {
      state.isLoading = input;
    },
    // 모바일 사이드바 토글
    toggleMobileSidenav(state) {
      state.isMobileSidenavOpen = !state.isMobileSidenavOpen;
    },
    closeMobileSidenav(state) {
      state.isMobileSidenavOpen = false;
    },
    setIntrospect(state, data) {
      state.introspect = data || null;
    },
    setPermLabels(state, labels) {
      state.permLabels = labels || {};
    },
    setGeoAllowPendingCount(state, count) {
      state.geoAllowPendingCount = count;
    },
    setMobileView(state, isMobile) {
      state.isMobileView = isMobile;
      if (!isMobile) {
        state.isMobileSidenavOpen = false;
      }
    },
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
    async requestAccessToken() {
      // 로그아웃한 뒤에는 남은 refresh 쿠키로 세션을 되살리지 않는다
      if (!canRefresh(localStorage.getItem("accessTokenCerti"))) return;
      // inapi 는 refresh 를 쿠키에서만 읽는다 — Authorization 헤더를 싣지 않고 쿠키로(W6 A7·K-19, CI-07)
      await axios.post(`${process.env.VUE_APP_SERVERURL}/auth/refresh`, null, refreshRequestConfig())
      .then((response) => {
        if(response.status === 200 || response.status === 201) {
          this.state.accessToken = response.data.accessToken;
          localStorage.setItem("accessTokenCerti", response.data.accessToken);
          // 새 refresh 는 쿠키로 온다. 본문에 있을 때만 옛 키도 맞춰 둔다
          if (response.data.refreshToken) {
            this.state.refreshToken = response.data.refreshToken;
            localStorage.setItem("refreshTokenCerti", response.data.refreshToken);
          }
          console.log("token issued");
        } else {
          console.log("token not issued");
          return;
        }
      })
      .catch(async (error) => {
        console.log(error);
        // 갱신 거절 = 쿠키 없음·만료·1시간 무활동·최대 12시간 → 로그인 화면
        if (isRefreshRejected(error)) {
          localStorage.clear();
          await openDialog(IDLE_LOGOUT_MESSAGE, "error", "확인");
          window.location.href = '/signin';
        }
      })
    },
    setUserInfo({ commit }, payload) {
      this.state.userName = payload.userName;
      this.state.userImageUrl = payload.userImageUrl;
    },
    clearLocalStorage({ commit }) {
      nextLoginGeneration(); // 로그아웃: 날아가는 중인 권한 재검토 응답은 버림
      commit("setIntrospect", null);
      localStorage.removeItem('accessTokenCerti');
      localStorage.removeItem('refreshTokenCerti');
      localStorage.removeItem('mfaTokenCerti');
      localStorage.removeItem('userNameCerti');
      localStorage.removeItem('userImageUrlCerti');
    },
  },
  getters: {
  },
  modules: {
    homepageEditor,
  },
});
